module.exports = __webpack_public_path__ + "img/banner3.cb935c1.png";